import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-secondary-500 bg-secondary-100 px-3 py-1 rounded-full">
            瓜友热评
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            瓜友热评
          </h2>
          <p className="text-sm text-foreground-600 mt-2">千万吃瓜群众的真实声音</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.author}
                  className="w-10 h-10 rounded-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div>
                  <span className="text-sm font-bold text-foreground-900">{item.author}</span>
                  <span className="text-xs text-foreground-500 ml-2">{item.time}</span>
                </div>
                <div className="ml-auto flex items-center gap-1 text-foreground-400">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs">{item.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}